import React,
{ useState } from 'react'
import { withRouter } from 'react-router-dom'

import {
  Button,
  Tabs 
} from '@driftt/dds'
import {
  Div,
  Layout,
  NavigationHeader,
} from '@driftt/tide-core'
import CSVImportLogs from 'components/Imports/ImportLogs/CSVImportLogs'
import MarketoImportLogs from 'components/Imports/ImportLogs/MarketoImportLogs/'
import PardotImportLogs from 'components/Imports/ImportLogs/PardotImportLogs/'
// import HubSpotImportLogs from 'components/Imports/ImportLogs/HubSpotImportLogs/';
import {
  getOrgMarketoAccessType,
  MarketoAccessTypes 
} from 'utils/marketoAccess'
import {
  getOrgPardotAccessType,
  PardotAccessTypes 
} from 'utils/pardotAccess'
// import { getOrgHubspotAccessType, HubspotAccessTypes } from 'utils/hubspotAccess';

const ImportListPage = ({
  history,
  orgId,
  onReceiveImports,
  imports
}) => {
  
  const MarketoTab = {
    label: 'Marketo imports',
    value: 'marketo',
    content: <MarketoImportLogs orgId={orgId}/>
  }
  const PardotTab = {
    label: 'Pardot imports',
    value: 'pardot',
    content: <PardotImportLogs orgId={orgId} history={history}/>
  }
  // TODO: jeff, hubspot import logs not supported on the backend as of 7/20/2020
  // const HubspotTab = {
  //   title: 'HubSpot imports',
  //   component: () => <HubSpotImportLogs {...this.props} />
  // }
  const CSVTab = {
    label: 'CSV imports',
    value: 'csv',
    content: <CSVImportLogs onReceiveImports={onReceiveImports} imports={imports}/>
  }

  let availableTabs = []
  if (getOrgMarketoAccessType() === MarketoAccessTypes.HAS_ACCESS_CONNECTED) {
    availableTabs.push(MarketoTab)
  }
  if (getOrgPardotAccessType() === PardotAccessTypes.HAS_ACCESS_CONNECTED) {
    availableTabs.push(PardotTab)
  }
  // TODO: jeff, hubspot import logs not supported on the backend as of 7/20/2020
  // if (getOrgHubspotAccessType() === HubspotAccessTypes.HAS_ACCESS_CONNECTED) {
  //   activeTabs.push(HubspotTab)
  // }
  availableTabs.push(CSVTab)

  const [activeTab, setActiveTab] = useState(availableTabs[1].value)

  return (
    <Div>
      <NavigationHeader title="Import logs">
        <Button
          onClick={() => history.push('/imports/upload')}
        >
            New import
        </Button>
      </NavigationHeader>
      <Layout>
        <Tabs options={availableTabs} activeTab={activeTab}
          onValueChange={setActiveTab} />
      </Layout>
    </Div>
  )
}


export default withRouter(ImportListPage)
